var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.valueData,
        expression: "valueData"
      }
    ],
    staticClass: "form-control",
    class: { "is-invalid": _vm.layoutData.errorText != null },
    attrs: { type: "text" },
    domProps: { value: _vm.valueData },
    on: {
      change: _vm.onChange,
      input: function($event) {
        if ($event.target.composing) {
          return
        }
        _vm.valueData = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }